(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cascade"] && !Shopify.designMode) return;
  try {
    
jq2 = jQuery.noConflict();
jq2(function( $ ) {
$(window).load(function() {
  $('.slick').slick();

  $('.slick').slickLightbox({
      src: 'src',
      itemSelector: '.slide img'
      });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expanding-slideshow"] && !Shopify.designMode) return;
  try {
    
  jq2 = jQuery.noConflict();
  jq2(function( $ ) {

    $('.slick').slick();
    $('.slick').slickLightbox({
        src: 'src',
        itemSelector: '.slide img',
        imageMaxHeight: 1,
        background: '#000000'
        });

    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-black"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-christa"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-daniella"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-down"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-event"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(window).keydown(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

	$(window).keydown(function(e){
        if (e.which == 39) {
           var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
        }
    });

    $(window).keydown(function(e){
        if (e.which == 37) {
           var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
        }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

$( ".grid-item" ).bind( "click", function() {
  alert( "User clicked on 'foo.'" );
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-eventdesign"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-exotic"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-exuberance"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-fairytale"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-farm"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-forest"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-interiorlandscaping"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-jungle"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-konichiwa"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-lavish"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-letlove"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-loveinjewel"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-luxop"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-making"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-max"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-neon"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-nicole"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-nyglam"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-oliver"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-puja"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-purple"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-romance"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-simplechic"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-social"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-sophis"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-thomas"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-veep"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-verawang"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-vinyard"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-weeklydeliveries"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-white"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-winter"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry2 img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry2").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry2").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-wonderful"]) return;
  try {
    

  $(window).load(function() {

    $("#masonry img").click(function() {
      $(".lightbox").fadeIn(300);
      $(".lightbox").append("<img src='" + $(this).attr("src") + "' alt='" + $(this).attr("alt") + "' />");
      /*$(".title").append("<h1>" + $(this).attr("alt") + "</h1>");*/
      $("html").css("overflow", "hidden");
      if ($(this).is(":last-child")) {
        $(".arrowr").css("display", "none");
        $(".arrowl").css("display", "block");
      } else if ($(this).is(":first-child")) {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "none");
      } else {
        $(".arrowr").css("display", "block");
        $(".arrowl").css("display", "block");
      }
    });

    $(".close").click(function() {
      $(".lightbox").fadeOut(300);
      $("h1").remove();
      $(".lightbox img").remove();
      $("html").css("overflow", "auto");
    });

    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".lightbox").fadeOut(300);
        $(".lightbox img").remove();
        $("html").css("overflow", "auto");
      }
    });

    $(".arrowr").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.next().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.next().is(":last-child")) {
        $(".arrowl").css("display", "block");
      } else {
        $(".arrowr").css("display", "none");
      }
    });

    $(".arrowl").click(function() {
      var imgSrc = $(".lightbox img").attr("src");
      var search = $("#masonry").find("img[src$='" + imgSrc + "']");
      var newImage = search.prev().attr("src");
      /*$(".lightbox img").attr("src", search.next());*/
      $(".lightbox img").attr("src", newImage);
      $(".filter").css("background-image", "url(" + newImage + ")");

      if (!search.prev().is(":first-child")) {
        $(".arrowr").css("display", "block");
      } else {
        $(".arrowl").css("display", "none");
      }
    });

  });

  } catch(e) { console.error(e); }
})();
})();
